module.exports = __webpack_public_path__ + "fonts/MicrogrammaD-BoldExte.590396c.woff";